import React from 'react'

import { default as MetaConsumer } from './consumer'
import { Provider as MetaProvider } from './context'
import SiteLogo from 'images/logo_round.svg'
import { useSiteQuery } from '@graphql/queries/__generated__/site.generated'
import { CLIENT_URL, SITE_NAME } from '../../../constants'

export const META_DEFAULTS = {
  custom: [],
  image: `${CLIENT_URL}${SiteLogo}`,
  defaultTitle: SITE_NAME,
  type: 'website',
  keywords: '',
  url: window.location.origin,
}

const removeEmpty = obj => {
  const newObj = {}
  Object.keys(obj).forEach(prop => {
    if (obj[prop] && obj[prop] !== '') {
      newObj[prop] = obj[prop]
    }
  })
  return newObj
}

interface IProps {
  meta?: any
  titleDetails?: string
}

const MetaWrapper: React.FC<IProps> = ({ meta = {}, titleDetails = '', children }) => {
  const siteQuery = useSiteQuery({ fetchPolicy: 'cache-first' })
  const { description, headerText, keywords, site } = siteQuery.data?.siteSettings || {}
  let title = headerText || SITE_NAME
  if (!!titleDetails) {
    title = `${titleDetails.charAt(0).toUpperCase() + titleDetails.toLowerCase().slice(1)} | ${site?.name || ''}`
  }
  const siteMeta = {
    title: title,
    description:
      description ||
      'We offer more than a 1000 counted cross stitch patterns for any taste:  cities, ' +
        'national parks, animals, Zodiac signs and so much more! Our patterns are available as PDFs to download upon ' +
        'purchase, or you can order our kits.',
    keywords: keywords || '',
  }
  return (
    <MetaProvider value={{ ...META_DEFAULTS, ...siteMeta, ...removeEmpty(meta) }}>
      <MetaConsumer>{children}</MetaConsumer>
    </MetaProvider>
  )
}

export default MetaWrapper
